import { render } from "./ProductGallery.vue?vue&type=template&id=62eae737&scoped=true"
import script from "./ProductGallery.vue?vue&type=script&lang=js"
export * from "./ProductGallery.vue?vue&type=script&lang=js"

import "./ProductGallery.vue?vue&type=style&index=0&id=62eae737&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62eae737"]])

export default __exports__